<template>
  <div id="lm-form-buider-preview">
    <LmComponentLoading v-if="loading" fixed />
    <LmFormBuilder
      ref="lmFormBuilder"
      :endpointUriwhereGetComponents="`formbuilder/${$route.params.idFormBuilder}`"
      :endpointUriWhereGetValuesToLoadInEditMode="$route.params.id && `delegaciones/${$route.params.id}`"
      @formObjectToSendToServerChange="updateForm($event)"
      />
    <portal to="portal-debajo-nombre">
      <h1>portal-debajo-nombre</h1>
    </portal>
    <portal to="destination-1">
      <LmTextInput
        v-model="form.portal1"
        :v="$v.form.portal1"
        class="col-12 col-md-6"
        label="Este se metió por la ventana"
        placeholder="portal"
        :max-length="6"
        />
    </portal>
    <portal to="destination-2">
      <LmTextInput
        v-model="form.portal2"
        :v="$v.form.portal2"
        class="col-12 col-md-6"
        label="Otro que Este se metió por la ventana"
        placeholder="portal"
        :max-length="6"
        />
    </portal>
    <portal to="button-submit">
      <div class="col-12">
        <LmButton
          value="Submit"
          type="submit"
          buttonClass="btn-primary"
          @click.native="submit"
          />
      </div>
    </portal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import lmFormMixinV2 from '@/mixins/lmFormMixinV2.js'

export default {
  mixins: [lmFormMixinV2],
  data () {
    return {
      form: {
        portal1: '',
        portal2: ''
      },
      initialForm: {}
    }
  },
  components: {
    LmFormBuilder,
    LmTextInput,
    LmButton
  },
  validations: {
    form: {
      portal1: {
        required
      },
      portal2: {
        required
      }
    }
  },
  methods: {
    async submit () {
      try {
        const lmFormBuilderValidations = this.validationForm(this.$refs.lmFormBuilder.$v, false)
        const formValidation = this.validationForm(this.$v, false)
        await Promise.all([lmFormBuilderValidations, formValidation])
        console.log('form submited')
        console.log('this.form', this.form)
      } catch (error) {
        this.showToastFormError()
      }
    },
    async setForm () {
      if (this.isOnEditMode) {
        await this.activeEditMode({
          // path: 'formbuilder',
          // id: this.$route.params.id,
          // paramsMode: true
        })
      } else {
        this.form = JSON.parse(this.initialForm)
        this.showLoading()
        setTimeout(() => {
          this.$v.$reset()
          this.hideLoading()
        }, 350)
      }
    },
    updateForm (formDataFromLmFormBuilder) {
      for (const key in formDataFromLmFormBuilder) {
        this.form[key] = formDataFromLmFormBuilder[key]
      }
    }
  },
  async created () {
    this.initialForm = JSON.stringify(this.form)
    this.isOnEditMode = !!this.$route.params.id
    this.setForm()
    await this.$nextTick()
    for (const key in this.$refs.lmFormBuilder.formObjectToSendToServer) {
      const value = this.$refs.lmFormBuilder.formObjectToSendToServer[key]
      this.$set(this.form, key, value)
    }
  }
}
</script>
